import { render, staticRenderFns } from "./PointSetting.vue?vue&type=template&id=6d6b6d7c&scoped=true"
import script from "./PointSetting.vue?vue&type=script&lang=js"
export * from "./PointSetting.vue?vue&type=script&lang=js"
import style0 from "./PointSetting.vue?vue&type=style&index=0&id=6d6b6d7c&prod&lang=scss"
import style1 from "./PointSetting.vue?vue&type=style&index=1&id=6d6b6d7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6b6d7c",
  null
  
)

export default component.exports